import { render, staticRenderFns } from "./entrustPrice.vue?vue&type=template&id=6d5439a2&scoped=true&"
import script from "./entrustPrice.vue?vue&type=script&lang=js&"
export * from "./entrustPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5439a2",
  null
  
)

export default component.exports